import React from "react";
import { useDeepMemo, useQuery, useSafeState } from "../../hooks";
import { ResourceEntityValues } from "../../utils/ResourceKeys";
import MuiTable from "../../components/MuiTable";
import InfoIcon from "@material-ui/icons/Info";
import InfoDrawer from "../system-activity/details/ActivityDetailsDrawer";
import { isEmpty } from "../../utils/helpers";
import { format } from "date-fns";
import { PageHeader } from "jazasoft";

const columns = [
  { dataKey: "event", title: "EVENT" },
  { dataKey: "searchText", title: "ENTITY VALUE" },
  { dataKey: "createdAt", title: "TIME" },
  { dataKey: "createdBy", title: "USER" }
];

const History = props => {
  const { i18nKey, id } = props.match.params;
  const entityName = ResourceEntityValues[i18nKey];
  const [drawerState, setDrawerState] = useSafeState({ open: false, userActivity: null });

  //* API call *//
  const { data: activityList = [] } = useQuery({
    url: "system-activities",
    params: { search: `entityName=='${entityName}';entityId==${id}`, sort: "id,desc" }
  });

  const rows = useDeepMemo(() => {
    if (isEmpty(activityList)) return [];
    return activityList.map(h => ({ ...h, createdAt: format(h.createdAt, "dd MMM, yyyy HH:mm a") }));
  }, [activityList]);

  const onInfoClick = (event, action, row, onActionComplete) => {
    setDrawerState({ open: true, userActivity: row });
  };

  return (
    <div>
      <PageHeader title="History" />

      <InfoDrawer
        open={drawerState?.open || false}
        userActivity={drawerState?.userActivity}
        onDrawerClose={() => setDrawerState({ open: false, userActivity: null })}
      />

      <div style={{ padding: "1.5rem", paddingTop: 0 }}>
        <MuiTable
          columns={columns}
          rows={rows}
          inlineActions={[{ name: "info", tooltip: "Info", icon: <InfoIcon />, align: "center" }]}
          onInlineActionClick={onInfoClick}
          // i18nKey="resources.orders.fields"
        />
      </div>
    </div>
  );
};

export default History;
